

var swiper = new Swiper (".routine_Swiper", {
    slidesPerView: 2,
    spaceBetween: 15
});

document.addEventListener('DOMContentLoaded', function() {
  const checkboxes = document.querySelectorAll('[id^="make_collapsible_open_checkbox_"]');

  checkboxes.forEach(checkbox => {
    const targetId = checkbox.dataset.target; // accordion id
    const accordion = document.getElementById(targetId);

    checkbox.addEventListener('change', function() {
      if (checkbox.checked) {
        accordion.setAttribute('open', 'true');
      } else {
        accordion.removeAttribute('open');
      }
    });
  });
});

// $(document).ready(function() {
//   $("details.mega-menu").each(function() {
//     const $detail = $(this);
//     const $summary = $detail.find("summary.header__menu-item");
//     const $content = $detail.find(".mega-menu__content");
//     debugger

//     // Hover in
//     $summary.add($content).on("mouseenter", function() {
//     debugger
//       $detail.attr("open", true);
//       $detail.closest(".template-index sticky-header")
//         .removeClass("header-wrapper--transparent")
//         .addClass("open-mega");
//     });

//     // Hover out
//     $summary.add($content).on("mouseleave", function(e) {
//     debugger
//       if (!$(e.relatedTarget).closest($detail).length) {
//         $detail.removeAttr("open");
//         $detail.closest(".template-index sticky-header")
//           .removeClass("open-mega")
//           .addClass("header-wrapper--transparent");
//       }
//     });
//   });
// });